import { TransitionStatus } from "react-transition-group";
import styled from "styled-components";
import { SidebarItemProps } from "../../SidebarItem.types.js";

type StyledSidebarItemBodyWrapperProps = {
    collapsed?: boolean;
    transitionDuration: number;
} & Pick<SidebarItemProps, "badge">;

const calculatePadding = (collapsed: boolean | undefined, badgeContentLength: number, theme: styled.DefaultTheme): string => {
    if (collapsed) {
        const paddingRightAndBottom = badgeContentLength > 1 ? `${theme.rem(1.2)} ${theme.rem(0.15)}` : `${theme.spacing[20]} ${theme.rem(0.375)}`;
        return `0 0 ${paddingRightAndBottom}`;
    }
    return `${theme.spacing[2]} ${theme.spacing[8]}`;
};

export const StyledSidebarItemBodyWrapper = styled.div<StyledSidebarItemBodyWrapperProps>`
    display: flex;
    align-items: center;
    gap: ${(props) => props.theme.spacing[12]};
    position: relative;
    width: 100%;
    ${({ collapsed, badge, theme, transitionDuration }) =>
        badge
            ? `&:after {
    font-size: ${badge.content.length > 1 ? theme.spacing["12"] : "inherit"};
    content: "${badge.content}";
    position: absolute;
    height: ${collapsed ? theme.spacing["16"] : "auto"};
    width: ${collapsed ? theme.spacing["20"] : "auto"};
    background-color: ${theme.colors[badge.color][100]};
    color: ${theme.grayscale[5]};
    padding: ${calculatePadding(collapsed, badge.content.length, theme)};
    border-radius: ${collapsed ? theme.radius.round : theme.radius.s};
    top: ${collapsed ? theme.rem(-1) : theme.rem(-0.125)};
    right: ${collapsed ? "-90%" : "0"};
    white-space: nowrap;
    transition: border-radius ${transitionDuration}ms linear, left ${transitionDuration}ms linear, top ${transitionDuration}ms linear;
  }`
            : ""}
`;

export const SidebarItemText = styled.div<{
    isOpen?: boolean;
    transitionDuration: number;
    transitionState: TransitionStatus;
}>`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: ${({ transitionState, isOpen }) =>
        isOpen !== undefined ? (!isOpen ? "none" : "inline") : transitionState === "exited" ? "none" : "inline"};
    opacity: ${({ transitionState }) => (transitionState === "entered" ? 1 : 0)};
    transition: opacity ${({ transitionDuration }) => transitionDuration * 0.75}ms
        ${({ transitionDuration, transitionState }) => (transitionState === "entered" ? transitionDuration * 0.25 : 0)}ms linear;
`;
